import { render, staticRenderFns } from "./SynthEdit.vue?vue&type=template&id=5b554d99&scoped=true&"
import script from "./SynthEdit.vue?vue&type=script&lang=js&"
export * from "./SynthEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b554d99",
  null
  
)

export default component.exports